import { render, staticRenderFns } from "./SearchVariantCategorySelector.vue?vue&type=template&id=43af9c05&"
import script from "./SearchVariantCategorySelector.vue?vue&type=script&lang=ts&"
export * from "./SearchVariantCategorySelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports